// SocialDrawer 组件的样式配置
export const drawerStyles = {
  body: {
    padding: '24px 40px 40px 40px',
    background: '#f7f8ff',
    overflow: 'auto',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
  },
  header: {
    padding: '24px 40px 0 40px',
    borderBottom: 'none',
    background: '#f7f8ff',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
  },
  content: {
    background: '#f7f8ff',
    overflow: 'auto',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
  },
  wrapper: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
  },
};
